<template>
  <div class="form">
    <div class="col-12">
      <list></list>
    </div>
  </div>
</template>

<script>
import List from '../components/documents/DocList.vue'
export default {
  components: {
    List
  }
}
</script>

<style>

</style>
